import { CoreMenu } from 'src/@core/types';

export const organizationMenu: CoreMenu[] = [
  {
    id: 'Policies',
    title: 'Policies',
    type: 'item',
    url: 'hr360/organization/policies',
    role: {
      roles: ['employee'],
      module: 'policies',
      right: '',
    },
  },
  {
    id: 'JDs',
    title: 'JDs',
    type: 'item',
    url: 'hr360/organization/jd',
    role: {
      roles: ['employee'],
      module: 'jd',
      right: '',
    },
  },
  {
    id: 'Organogram',
    title: 'Organogram',
    type: 'item',
    url: `hr360/organization/organogram`,
    role: {
      roles: ['employee'],
      module: 'organogram',
      right: '',
    },
  },
];
